<template>
  <b-row class="hp-authentication-page">
    <left-item />

    <b-col cols="12" lg="6" class="py-sm-64 py-lg-0">
      <b-row align-v="center" align-h="center" class="h-100 mx-4 mx-sm-n32">
        <b-col
          cols="12"
          md="9"
          xl="7"
          class="col-xxxl-5 px-8 px-sm-0 pt-24 pb-48"
        >
          <h1 class="mb-0 mb-sm-24">Восстановление пароля</h1>
          <p class="mt-sm-8 mt-sm-0 text-black-60">
            Мы пришлем вам на почту инструкции по смене пароля.
          </p>

          <b-form @submit="onSubmit" class="mt-16 mt-sm-32 mb-8">
            <ValidationObserver v-slot="{ valid }">
              <validation-provider
                name="email"
                :rules="{ required: true, email: true }"
                v-slot="{ dirty, valid, invalid, errors }"
              >
                <b-form-group
                  label="E-mail:"
                  label-for="recoverEmail"
                  class="mb-16"
                >
                  <b-form-input
                    :disabled="waiting_code"
                    id="recoverEmail"
                    type="email"
                    placeholder="you@example.com"
                    v-bind:class="{
                      'is-valid': dirty && valid,
                      'is-invalid': dirty && invalid,
                    }"
                    v-model="email"
                  ></b-form-input>
                </b-form-group>
              </validation-provider>
              <b-button
                :disabled="!valid"
                v-if="!waiting_code"
                @click="sendCode()"
                variant="primary"
                class="w-100"
              >
                Прислать код на почту
              </b-button>
            </ValidationObserver>

            <ValidationObserver v-slot="{ valid }">
              <validation-provider
                name="код"
                :rules="{ required: true, regex: /^[a-zA-Z0-9]{5,}$/ }"
                v-slot="{ dirty, valid, invalid, errors }"
              >
                <b-form-group
                  v-if="waiting_code"
                  label="Ваш код:"
                  label-for="recoverCode"
                  class="mb-16"
                >
                  <b-form-input
                    id="recoverCode"
                    type="text"
                    placeholder="XXXXX"
                    v-bind:class="{
                      'is-valid': dirty && valid,
                      'is-invalid': dirty && invalid,
                    }"
                    v-model="code"
                  ></b-form-input>
                </b-form-group>
                
                <b-button v-if="waiting_code" type="submit" :disabled="!valid" variant="primary" class="w-100">
                  Ввести новый пароль
                </b-button>
              </validation-provider>
            </ValidationObserver>
          </b-form>

          <div class="hp-form-info text-center">
            <span class="text-black-80 hp-text-color-dark-40 hp-caption mr-4">
              Вернуться к
            </span>
            <b-link
              class="hp-cursor-pointer text-primary-1 hp-text-color-dark-primary-2 hp-caption"
              to="/pages/authentication/login"
            >
              входу
            </b-link>
          </div>

          <footer-item />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BLink,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
} from "bootstrap-vue";

import LeftItem from "../LeftItem.vue";
import FooterItem from "../FooterItem.vue";
import axios from "axios";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BLink,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    LeftItem,
    FooterItem,
  },
  data() {
    return {
      email: "",
      waiting_code: false,
      code: "",
      error: null
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.confirmCode();
    },
    async sendCode() {
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/auth/recover/get_code`,
          {
            email: this.email,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        this.waiting_code = true;
        console.log(data);
        localStorage.setItem("token", data.data);
      } catch (e) {
        console.log(e);
        this.waiting_code = false;
        this.error = "Неправильный логин или пароль";
      }
    },
    async confirmCode() {
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/auth/recover/confirm_code`,
          {
            code: this.code,
            token: localStorage.getItem("token"),
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log(data);
        localStorage.setItem("token", data.data);
        this.$router.replace({ path: "/pages/authentication/reset-password" });
      } catch (e) {
        console.log(e);
        this.error = "Код неверный";
      }
    },
  },
};
</script>
